module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-color": "#efefef",
      "background-attachment": "fixed"
    }
  }, [_c('div', {
    staticClass: "container g-pt-60 g-pb-30"
  }, [_c('div', {
    staticClass: "row justify-content-lg-center align-items-md-center"
  }, [_c('div', {
    staticClass: "col-md-9 col-lg-7 g-mb-30"
  }, [_c('div', {
    staticClass: "media align-items-center g-pr-15--lg"
  }, [_c('div', {
    staticClass: "media-body"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Don’t see the guide or resource you are looking for?")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" and suggest a new resource that would be helpful.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4 col-lg-3 mx-auto g-mx-0--lg g-mb-30"
  }, [_c('a', {
    staticClass: "btn btn-block u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-25 g-py-13 g-font-size-18",
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      }
    }
  }, [_vm._v("Submit a Suggestion")])])])]), _vm._v(" "), (_vm.isModalShown) ? _c('suggest-form', {
    on: {
      "closeWufoo": function($event) {
        return _vm.CloseModal()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d3bed8a4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3bed8a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/resourceData/ResourceSuggest.vue
// module id = 574
// module chunks = 4